(function () {
    'use strict';

    angular
        .module('bcmModule')
        .controller('biaResponsibilityListController', Controller);

    Controller.$inject = ['$scope', 'bcmService'];

    function Controller($scope, bcmService) {

        if (_.isUndefined($scope.ctrlCtxt)) $scope.ctrlCtxt = {};

        $scope.ctrlCtxt.priorityLevels = $scope.priorityLevels;
        $scope.ctrlCtxt.ratingsNeeded =
            _.get($scope, 'boxContext.BUOwner.NextItemTaskDefinition.Value') === 'NeedAllBIARespRatedForBUOwner';

        // Group BIA Responsibilities by Priority Level
        $scope.ctrlCtxt.groupedByPriorityPromise = groupBIARespsByPriorityLevel();
        $scope.$on('need-refresh', groupBIARespsByPriorityLevel);

        function groupBIARespsByPriorityLevel() {
            $scope.unRatedBIAResponsibilities = _.filter($scope.boxModel, { IsRated: false });

            // Get rated BIA Responsibilities 
            var ratedBIARespsByPriorityLevel = _
                .chain($scope.boxModel)
                .filter({IsRated: true})
                .groupBy('PriorityLevelID')
                .value();

            return bcmService
                .getBCMLookups()
                .then(function (container) {
                    $scope.ratedBIARespsByPriority = _.cloneDeep(container.PriorityLevelsByID);
                    $scope.ratedBIARespsByPriority = _
                        .chain($scope.ratedBIARespsByPriority)
                        .map(function (priorityLevel, priorityLevelId) {
                            var mapped = {
                                PriorityLevel: priorityLevel,
                                BIAResponsibilities: ratedBIARespsByPriorityLevel[priorityLevelId] || []
                            };
                            return mapped;
                        })
                        .value();

                    $scope.ratedBIARespsButNotPrioritized = ratedBIARespsByPriorityLevel[undefined] || [];
                });
        }
    }
})();